/**
 * How tightly a stored table packs into the page width.
 */

import { readString } from '@/domain/json'
import type { JsonValue } from '@/domain/json'
import type { TableFit } from '@/domain/section'

const TABLE_FITS = new Set<TableFit>(['normal', 'shrink', 'compact'])

/** Anything unknown falls back to normal, so an old report keeps its look. */
export function readTableFit(stored: JsonValue): TableFit {
  const value = readString(stored, 'fit', 'normal')
  return TABLE_FITS.has(value as TableFit) ? (value as TableFit) : 'normal'
}
